export const CLICK = 'click'
export const ENTER = 'Enter'
